import React from 'react';
import { motion } from 'framer-motion';
import { Activity, Clock, Target, Calendar } from 'lucide-react';

interface ClientWorkoutHistoryProps {
  clientId: string;
}

export function ClientWorkoutHistory({ clientId }: ClientWorkoutHistoryProps) {
  const workouts = [
    {
      id: 1,
      date: '2024-03-10',
      name: 'Full Body Strength',
      duration: 60,
      strain: 14.2,
      metrics: {
        recovery: 85,
        sleep: 92,
        readiness: 88
      }
    },
    {
      id: 2,
      date: '2024-03-08',
      name: 'HIIT Circuit',
      duration: 45,
      strain: 15.8,
      metrics: {
        recovery: 78,
        sleep: 85,
        readiness: 82
      }
    },
    {
      id: 3,
      date: '2024-03-06',
      name: 'Recovery Flow',
      duration: 30,
      strain: 8.5,
      metrics: {
        recovery: 92,
        sleep: 88,
        readiness: 90
      }
    }
  ];

  return (
    <div className="theme-card p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <Activity className="w-5 h-5 text-primary" />
          <h2 className="text-lg font-semibold">Workout History</h2>
        </div>
        <button className="text-sm text-primary hover:text-primary/80 transition-colors">
          View All
        </button>
      </div>

      <div className="space-y-4">
        {workouts.map((workout, index) => (
          <motion.div
            key={workout.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="bg-muted/30 p-4 rounded-lg space-y-3"
          >
            <div className="flex items-center justify-between">
              <div>
                <div className="font-medium">{workout.name}</div>
                <div className="flex items-center gap-4 text-sm text-muted-foreground">
                  <div className="flex items-center gap-1">
                    <Calendar className="w-3 h-3" />
                    <span>{workout.date}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Clock className="w-3 h-3" />
                    <span>{workout.duration} min</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Target className="w-3 h-3" />
                    <span>{workout.strain} strain</span>
                  </div>
                </div>
              </div>
              <button className="text-primary hover:text-primary/80 transition-colors">
                View Details
              </button>
            </div>

            <div className="grid grid-cols-3 gap-4 pt-2 border-t border-border">
              <div>
                <div className="text-xs text-muted-foreground">Recovery</div>
                <div className="font-medium">{workout.metrics.recovery}%</div>
              </div>
              <div>
                <div className="text-xs text-muted-foreground">Sleep</div>
                <div className="font-medium">{workout.metrics.sleep}%</div>
              </div>
              <div>
                <div className="text-xs text-muted-foreground">Readiness</div>
                <div className="font-medium">{workout.metrics.readiness}%</div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}